import styled from 'styled-components';

import { themeColors } from 'theme';

export const PrimaryLink = styled.a`
  color: ${themeColors.primary};
  font-weight: 500;
  line-height: 23px;
`;
